export default __webpack_public_path__ + "assets/solar-eclipse.196dacfa.svg";